import { useState } from 'react'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import { pb } from '@/pb'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
  MenuItem,
  ListItemText,
  Paper,
  Tabs,
  Tab
} from '@mui/material'
import { Scanner } from '@yudiel/react-qr-scanner'
import { getWorkoutTitle } from './util'

export default function StartTrainingScreen({
  workoutTemplates,
  workoutTemplatesLoaded,
  onStart
}) {
  const [tab, setTab] = useState(0);
  const [scanType, setScanType] = useState(null);

  const [selectedWorkoutId, setSelectedWorkoutId] = useState('');
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [deviceLoading, setDeviceLoading] = useState(false);
  const [workoutGroupChecked, setWorkoutGroupChecked] = useState(false);

  const [selectedGroup, setSelectedGroup] = useState(null);

  const handleScan = async (codes) => {
    const value = codes?.[0]?.rawValue || '';
    if (!value) return;

    if (scanType === 'DEVICE') {
      try {
        setDeviceLoading(true);
        const device = await pb.collection('devices').getFirstListItem(`deviceId="${value}"`);
        setSelectedDevice(device);
      } catch (err) {
        console.error("Device not found", err);
        setSelectedDevice(null);
      } finally {
        setDeviceLoading(false);
        setScanType(null);
      }
    } else if (scanType === 'GROUP') {
      console.log(value)
      try {
        const group = await pb.collection('workout_groups').getOne(value);
        console.log(group)
        setSelectedGroup(group);
      } catch (err) {
        console.error("Group not found", err);
        setSelectedGroup(null);
      } finally {
        setScanType(null);
      }
    }
  };

  const handleStart = () => {
    onStart({ 
      workoutId: tab === 0 ? selectedWorkoutId : selectedGroup?.templateId, 
      device: selectedDevice,
      groupId: tab === 1 ? selectedGroup?.id : null,
      startTime: tab === 1 ? selectedGroup?.startTime : 0 
    });
  };

  return (
    <Box sx={{ p: 2, display: "flex", gap: "1rem", flexDirection: "column" }}>
      <Typography variant="h5" sx={{ fontWeight: 900 }}>
        Настройка тренировки
      </Typography>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="fullWidth">
        <Tab label="Одиночная" />
        <Tab label="Групповая" />
      </Tabs>

      {tab === 0 && (
        <Paper elevation={2} sx={{ p: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: "1rem" }}>
            Шаблон
          </Typography>

          <TextField
            select
            label="Выберите шаблон"
            value={selectedWorkoutId}
            onChange={(e) => setSelectedWorkoutId(e.target.value)}
            fullWidth
            slotProps={{
              select: {
                renderValue: (selected) => {
                  if (!selected) return <em>Не выбрано</em>;
                  const selectedWorkout = workoutTemplates.find((w) => w.id === selected);
                  return selectedWorkout ? getWorkoutTitle(selectedWorkout) : '';
                }
              }
            }}
          >
            <MenuItem value="">
              <em>Не выбрано</em>
            </MenuItem>
            {workoutTemplatesLoaded &&
              workoutTemplates.map((w) => (
                <MenuItem key={w.id} value={w.id}>
                  <ListItemText
                    primary={getWorkoutTitle(w)}
                    secondary={w.description}
                    slotProps={{ secondary: { sx: { color: 'text.secondary' }, noWrap: true } }}
                  />
                </MenuItem>
              ))}
          </TextField>
        </Paper>
      )}

      <Paper elevation={2} sx={{ p: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>Груша</Typography>
          </Stack>
          <Button
            size="medium"
            variant="outlined"
            startIcon={<QrCodeScannerIcon />}
            onClick={() => setScanType('DEVICE')}
            disabled={deviceLoading}
          >
            {selectedDevice?.deviceId ? `Груша: ${selectedDevice?.deviceId}` : "Сканировать QR груши"}
          </Button>
        </Box>
      </Paper>

      {tab === 1 && (
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle1" sx={{
                fontWeight: 800,
                color: 'text.primary',
              }}>
                Групповая тренировка
              </Typography>
            </Stack>
            <Button
              size="medium"
              variant="outlined"
              startIcon={<QrCodeScannerIcon />}
              onClick={() => setScanType('GROUP')}
            >
              {selectedGroup?.id ? `Группа: ${selectedGroup?.name}` : "Сканировать QR группы"}
            </Button>
          </Box>
        </Paper>
      )}

      <Button
        fullWidth
        variant="contained"
        disabled={!selectedDevice || (tab === 0 && !selectedWorkoutId) || (tab === 1 && !selectedGroup?.id)}
        onClick={handleStart}
      >
        Начать
      </Button>

      <Dialog open={!!scanType} onClose={() => setScanType(null)} fullScreen>
        <DialogTitle>
          {scanType === 'DEVICE' ? 'Сканируйте QR груши' : 'Сканируйте QR группы'}
        </DialogTitle>
        <DialogContent sx={{ p: 0 }} className="custom-scanner">
          <Scanner
            onScan={handleScan}
            components={{ audio: false, onOff: false, torch: true, zoom: true, finder: true }}
            sound={null}
            onError={(err) => console.error(err)}
          />
        </DialogContent>
      </Dialog>
    </Box>
  )
}